/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_DeleteInputs */

const vi_media_delete = /** @type {(inputs: Media_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá file`)
};

/**

* @param {Media_DeleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_delete = /** @type {((inputs?: Media_DeleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_DeleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_delete(inputs)
});